module.exports = __webpack_public_path__ + "static/media/logo.fe5f630c.svg";